import { connect } from 'react-redux'
import { deleteCellItem, updateCellItem, deleteElementItem, updateElementItem,
  moveElementItem
} from 'actions/form_builder_actions'

export default connect((state) => ({
}), { deleteCellItem, updateCellItem, deleteElementItem, updateElementItem, moveElementItem })
